import { useState } from "react"
import { CandidatesTab } from "../../components/candidatesTab"
import { FavoriteCandidatesTab } from "../../components/favoriteCandidatesTab"
import {
    useGetActiveCandidates,
    useGetFavouriteCandidates,
    useGetHistoryCandidates,
} from "../../hooks/candidate-hooks"

export const CandidatesPage = () => {
    const { candidates: activeCandidates, isLoading: activeCandidatesLoading } =
        useGetActiveCandidates()
    const { candidates: favoriteCandidates, isLoading: favoriteCandidatesLoading } =
        useGetFavouriteCandidates()
    const { candidates: historyCandidates, isLoading: historyCandidatesLoading } =
        useGetHistoryCandidates()

    const [isCurrentCandidatesTabActive, setIsCurrentCandidatesTabActive] = useState(true)
    const [isCandidatesTabActive, setIsCandidatesTabActive] = useState(true)

    const onCandidatesTabClicked = () => {
        setIsCandidatesTabActive(true)
    }

    const onFavoritesTabClicked = () => {
        setIsCandidatesTabActive(false)
    }

    const onCurrentCandidatesClicked = () => {
        setIsCurrentCandidatesTabActive(true)
    }

    const onIstoricCandidateClicked = () => {
        setIsCurrentCandidatesTabActive(false)
    }

    return (
        <div id="candidates-page" className="w-full px-4 py-4 sm:px-6 sm:py-6">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                <div className="mt-0 sm:mt-2">
                    <h3 className="page-title text-[24px] sm:text-[28px] md:text-[32px]">
                        Candidații tăi
                    </h3>
                    <p className="page-description text-sm sm:text-base">
                        Alege candidații tăi
                    </p>
                </div>

                <div className="mt-0 sm:mt-2 inline-flex w-full rounded-[12px] bg-figmaLightGray p-1 sm:w-auto">
                    <button
                        type="button"
                        onClick={onCandidatesTabClicked}
                        className={`candidates-tab flex-1 rounded-[10px] px-4 py-2 text-sm sm:px-6 sm:text-[14px] text-figmaDarkGray ${
                            isCandidatesTabActive ? "active-tab" : ""
                        }`}
                    >
                        <p>Candidați</p>
                    </button>

                    <button
                        type="button"
                        onClick={onFavoritesTabClicked}
                        className={`candidates-tab flex-1 rounded-[10px] px-4 py-2 text-sm sm:px-6 sm:text-[14px] text-figmaDarkGray ${
                            !isCandidatesTabActive ? "active-tab" : ""
                        }`}
                    >
                        <p>Favoriți</p>
                    </button>
                </div>
            </div>

            <div className="mt-6 sm:mt-8">
                {isCandidatesTabActive ? (
                    <CandidatesTab
                        onCurrentCandidatesClicked={onCurrentCandidatesClicked}
                        onIstoricCandidateClicked={onIstoricCandidateClicked}
                        isCurrentCandidatesTabActive={isCurrentCandidatesTabActive}
                        candidates={
                            isCurrentCandidatesTabActive ? activeCandidates : historyCandidates
                        }
                        loading={
                            isCurrentCandidatesTabActive
                                ? activeCandidatesLoading
                                : historyCandidatesLoading
                        }
                    />
                ) : (
                    <FavoriteCandidatesTab
                        candidates={favoriteCandidates}
                        loading={favoriteCandidatesLoading}
                    />
                )}
            </div>
        </div>
    )
}